const authorityFields = [
  'byUserID',
  'organizationID',
  'organizationMasterID',
  'source',
  'createdAt',
] as const

/** Updates keep the stored owner, team and provenance. Project reassignment
 * remains explicit and is checked by the backend against its destination. */
export const buildSavedSearchUpdateInput = <T extends { id: string }>(
  input: T,
) =>
  Object.fromEntries(
    Object.entries(input).filter(
      ([field]) =>
        !authorityFields.includes(field as (typeof authorityFields)[number]),
    ),
  ) as Omit<T, (typeof authorityFields)[number]>
